import { render, staticRenderFns } from "./subMemberReview.vue?vue&type=template&id=556d0a25&"
import script from "./subMemberReview.vue?vue&type=script&lang=js&"
export * from "./subMemberReview.vue?vue&type=script&lang=js&"
import style0 from "./subMemberReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "subMemberReview.vue"
export default component.exports